import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { Spinner } from "@tellescope/ui";
import { getApiURL } from "../../../config/api";

/**
 * Handles shortened redirect links (/r/:token) for white-labeled domains.
 *
 * When a customer has a custom DNS (white-labeled domain), shortened links
 * in patient-facing messages point to their portal URL. This component
 * redirects to the Tellescope API which resolves the token and redirects
 * to the actual destination.
 */
export const RedirectHandler = () => {
  const { token } = useParams<{ token: string }>();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!token) return;

    // Build API redirect URL
    const apiUrl = getApiURL();
    const redirectUrl = new URL(`/r/${token}`, apiUrl);

    // Preserve any query params from the original URL
    searchParams.forEach((value, key) => {
      redirectUrl.searchParams.set(key, value);
    });

    // Redirect to API
    window.location.replace(redirectUrl.toString());
  }, [token, searchParams]);

  // Show spinner while redirecting
  return (
    <div className="flex items-center justify-center min-h-screen">
      <Spinner />
    </div>
  );
};
